import { render } from "./GoldLayout.vue?vue&type=template&id=5ad2324a&scoped=true&ts=true"
import script from "./GoldLayout.vue?vue&type=script&lang=ts"
export * from "./GoldLayout.vue?vue&type=script&lang=ts"

import "./GoldLayout.vue?vue&type=style&index=0&id=5ad2324a&scoped=true&lang=scss"
import "./GoldLayout.vue?vue&type=style&index=1&id=5ad2324a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad2324a"]])

export default __exports__